import React from 'react';
import { connect } from 'react-redux';
import { auth } from '../../firebase';
import { default as SESSION_ACTIONS } from '../../reducers/session';

function ConnectedNav(props) {
  const { user } = props;
  const tryLogOut = () => auth.signOut().then(() => props.logOut());

  return (
    <button
      onClick={tryLogOut}
      type="button"
      className="io-unbutton pill-button txt-uppercase"
    >
      OUT {user.email.replace(/@[^@]+$/, '')}
    </button>
  );
}

const select = state => {
  return {
    user: state.session.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    logOut: _ => dispatch(SESSION_ACTIONS.logOut()),
  };
};

const LogOut = connect(select, mapDispatchToProps)(ConnectedNav);

export default LogOut;
